// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Then would the waters have overwhelmed us<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and the torrent gone over our soul;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;over our soul would have swept the raging waters.<br> </p> </div></div>";
// Exports
module.exports = code;